import { cn } from "../ui/cn";
import { H3 } from "../ui/Heading";
import { ChatThread } from "../chat/ChatThread";
import type { Moment } from "../data/moments";

export function MomentRow({ moment, reverse }: { moment: Moment; reverse: boolean }) {
  return (
    <div className="grid grid-cols-2 gap-16 items-center max-md:grid-cols-1 max-md:gap-9">
      <div className={cn(reverse ? "order-2 max-md:order-none" : "order-1")}>
        <div className="flex items-center gap-3.5">
          <span className="font-mono text-[32px] font-semibold tracking-tight text-accent">
            {moment.time}
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-td-3 px-2.5 py-1 rounded-full border border-dashed border-dash-d">
            {moment.tag}
          </span>
        </div>
        <H3 className="text-[32px] leading-[1.15] mt-5">{moment.heading}</H3>
        <p className="mt-3.5 text-base leading-relaxed text-td-2">{moment.body}</p>
      </div>
      <div className={cn(reverse ? "order-1 max-md:order-none" : "order-2")}>
        <ChatThread
          messages={moment.msgs}
          height={moment.chatHeight ?? 380}
          loopRestartMs={moment.loopRestartMs}
        />
      </div>
    </div>
  );
}
